import { useTranslation } from "react-i18next";
import { Quotes } from "@phosphor-icons/react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const ITEMS = [1, 2, 3] as const;

const offsets = ["lg:translate-y-0", "lg:translate-y-10", "lg:-translate-y-4"];

export function Testimonials() {
  const ref = useScrollReveal<HTMLElement>();
  const { t } = useTranslation();

  return (
    <section
      ref={ref}
      className="animate-on-scroll bg-white py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Editorial header */}
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-8">
          <div className="col-span-12 lg:col-span-7">
            <h2 className="font-heading text-3xl leading-[1.1] font-bold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
              {t("forCompaniesPage.testimonials.title")}
            </h2>
          </div>
        </div>

        {/* Staggered cards */}
        <div className="mt-16 grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-10">
          {ITEMS.map((n, i) => (
            <figure
              key={n}
              className={`relative flex flex-col rounded-2xl bg-white p-8 transition-all duration-500 hover:-translate-y-1 sm:p-9 ${offsets[i]}`}
              style={{
                border: "1px solid var(--color-warm-border)",
                boxShadow:
                  "0 1px 0 oklch(96% 0.01 84), 0 24px 48px -32px oklch(60% 0.05 84 / 0.18)",
              }}
            >
              <Quotes
                aria-hidden
                weight="fill"
                className="absolute -top-3 left-7 size-9 rounded-full bg-white p-1.5"
                style={{
                  color: "var(--color-brand-dark)",
                  border: "1px solid var(--color-warm-border)",
                }}
              />

              <blockquote className="font-heading mt-2 text-lg leading-snug text-foreground italic sm:text-xl">
                <span
                  className="text-3xl leading-none"
                  style={{ color: "var(--color-brand-dark)" }}
                >
                  &ldquo;
                </span>
                {t(`forCompaniesPage.testimonials.quote${n}`)}
              </blockquote>

              <figcaption
                className="mt-7 border-t pt-5 text-sm"
                style={{ borderColor: "var(--color-warm-border)" }}
              >
                <div className="font-semibold text-foreground">
                  {t(`forCompaniesPage.testimonials.name${n}`)}
                </div>
                <div className="mt-0.5 text-xs uppercase tracking-[0.12em] text-muted-foreground/80">
                  {t(`forCompaniesPage.testimonials.role${n}`)}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
